import script from "./LearningsModeration.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningsModeration.vue?vue&type=script&setup=true&lang=js"

import "./LearningsModeration.vue?vue&type=style&index=0&id=02d48154&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d48154"]])

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
